module.exports = __webpack_public_path__ + "static/media/res.75fcdd14.png";